import { render, staticRenderFns } from "./VideoItem1.vue?vue&type=template&id=63e88958"
import script from "./VideoItem1.vue?vue&type=script&lang=js"
export * from "./VideoItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports